import { Button, Modal, Form, Col, Row } from 'react-bootstrap'
import MajorCourseService from '../../service/majorCourseService'
import { successNotify, errorNotify } from '../Utils/Toast'
import useToken from '../../App/useToken'
import React, { useState, useEffect } from 'react'

import './MajorCourseEditModal.css'

export default function MajorCourseEditModal({
  getMajorCourse,
  majorCourseChange,
  showMajorCourseEditModal,
  setShowMajorCourseEditModal,
}) {
  const { getToken } = useToken()
  const token = getToken()
  const [name, setName] = useState()
  const [expert, setExpert] = useState()
  const [description, setDescription] = useState()
  const [isActive, setisActive] = useState(majorCourseChange?.is_active)
  const [isSpcApprove, setIsSpcApprove] = useState(
    majorCourseChange?.is_spc_approve,
  )

  const handleClose = () => {
    setShowMajorCourseEditModal(false)
  }

  const handleOnSave = async (e) => {
    e.preventDefault()
    const majorCourseService = new MajorCourseService()
    const res = await majorCourseService.updateMajorCourse(
      token,
      majorCourseChange?._id,
      {
        name,
        description,
        expert,
        is_active: isActive,
        is_spc_approve: isSpcApprove,
      },
    )
    if (res.type != 'error') {
      successNotify('แก้ไขข้อมูลสำเร็จ')
      getMajorCourse()
    } else {
      errorNotify(res?.message?.message || 'เกิดข้อผิดพลาด')
    }
    setShowMajorCourseEditModal(false)
  }

  return (
    <>
      <Modal
        show={showMajorCourseEditModal}
        onHide={handleClose}
        backdrop='static'
        keyboard={false}
        centered
        size='lg'>
        {majorCourseChange && (
          <Form onSubmit={handleOnSave}>
            <Modal.Header closeButton>
              <Modal.Title>แก้ไข</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col md={6}>
                  <Form.Group
                    as={Col}
                    onChange={(e) => setName(e.target.value)}>
                    <Form.Label>ชื่อหลักสูตร :</Form.Label>
                    <Form.Control defaultValue={`${majorCourseChange?.name}`} />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group
                    as={Col}
                    onChange={(e) => setDescription(e.target.value)}>
                    <Form.Label>คำอธิบาย :</Form.Label>
                    <Form.Control
                      as='textarea'
                      value={majorCourseChange?.description}
                    />
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group as={Col}>
                    <Form.Label>รหัสหลักสูตร :</Form.Label>
                    <Form.Control
                      value={majorCourseChange?.pme_no || '-'}
                      disabled
                    />
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group
                    as={Col}
                    onChange={(e) => setExpert(e.target.value)}>
                    <Form.Label>ระดับความชำนาญ :</Form.Label>
                    <Form.Control
                      defaultValue={majorCourseChange?.expert}
                      type='number'
                      min='0'
                      max='10'
                    />
                  </Form.Group>
                </Col>
                <Col md={2}>
                  <Form.Group
                    as={Col}
                    onChange={(e) => setisActive(e.target.checked)}>
                    <Form.Label>เปิดใช้งาน :</Form.Label>
                    <Form.Check
                      defaultChecked={majorCourseChange?.is_active}
                      type='switch'
                      id='custom-switch'
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group
                    as={Col}
                    onChange={(e) => setIsSpcApprove(e.target.checked)}>
                    <Form.Label>ผ่านหน่วย หน. สายวิทยาการ :</Form.Label>
                    <Form.Check
                      defaultChecked={majorCourseChange?.is_spc_approve}
                      type='switch'
                      id='custom-switch'
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button variant='secondary' onClick={handleClose}>
                ปิด
              </Button>
              <Button variant='primary' type='submit'>
                บันทึก
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Modal>
    </>
  )
}
